import React, { useRef } from "react";

import StopIcon from "../assets/icons/StopIcon";
import UpArrow from "../assets/icons/UpArrow";
import useAutosizeTextArea from "../hooks/useAutosizeTextArea";

const ChatInput = ({
  prompt,
  isFetchingResponse,
  setPrompt,
  handleSend,
  stopFetchingResponse,
}) => {
  const textAreaRef = useRef(null);
  useAutosizeTextArea(textAreaRef.current, prompt);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey) {
        setPrompt(prompt + "\n");
      } else {
        handleSend();
      }
      event.preventDefault();
    }
  };

  const handleChange = (event) => {
    setPrompt(event.target.value);
  };

  return (
    <div className="w-full mt-auto flex flex-col justify-center items-center mx-auto gap-3 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl">
      <div className="relative overflow-hidden justify-between bg-inherit flex rounded-xl w-full  border border-zinc-700">
        <textarea
          ref={textAreaRef}
          className="w-full bg-inherit pr-10 text-md outline-none p-3 resize-none overflow-auto placeholder-zinc-500"
          placeholder="How can I help you?"
          value={prompt}
          onChange={handleChange}
          rows={1}
          onKeyDown={handleKeyDown}
          disabled={isFetchingResponse}
        />

        {isFetchingResponse ? (
          <button
            className="absolute flex justify-center items-center hover:bg-red-500 hover:text-gray-200 hover:border-red-500 right-2  border border-zinc-400 bottom-2 w-8 self-end h-8  text-zinc-400 rounded-md"
            onClick={stopFetchingResponse}
          >
            <StopIcon className="w-4 h-full" />
          </button>
        ) : (
          <button
            disabled={!prompt.length}
            className={`${
              !prompt.length ? "opacity-20" : ""
            } absolute right-2 bottom-2 w-8 self-end h-8 bg-gray-50 text-gray-900 rounded-md`}
            onClick={handleSend}
          >
            <UpArrow className="w-full h-4" />
          </button>
        )}
      </div>
      <p className="m-2 text-xs text-zinc-500">
        {/* Gen AI may produce incorrect results as its still under development. */}
      </p>
    </div>
  );
};

export default ChatInput;
